import {
    getBonusCardRequestedStates,
    hasLocalStorageTimestamp,
    setBonusCardRequestedStates
} from "@/utils/bonusCard";
import { BonusCardStatus } from "@/utils/enums";

export const setBonusCardRequestedState = (email: string) => {
    try {
        const state = getBonusCardRequestedStates();
        setBonusCardRequestedStates([
            ...(state || []),
            {
                email,
                timeStamp: Date.now().toString()
            }
        ]);
    } catch (err) {
        console.error(err);
    }
};

export const removeBonusCardRequestedState = (email: string) => {
    try {
        const state = getBonusCardRequestedStates();
        if (!state) {
            return;
        }
        const newState = state.filter((s) => s.email !== email);
        setBonusCardRequestedStates([...newState]);
    } catch (err) {
        console.error(err);
    }
};

export const getStatus = (customer: {
    bonusCardNumber?: null | string;
    eBonusCardNumber?: null | string;
    bonusCardRequested?: null | boolean;
    email: string;
}) => {
    if (customer.bonusCardNumber || customer.eBonusCardNumber) {
        return BonusCardStatus.HasCard;
    }

    if (customer?.bonusCardRequested && !customer.bonusCardNumber) {
        return BonusCardStatus.CardOnRoute;
    }

    if (
        customer &&
        hasLocalStorageTimestamp(customer.email) &&
        !customer.bonusCardRequested
    ) {
        return BonusCardStatus.Requested;
    }

    return BonusCardStatus.NoCard;
};
